<template>
  <div>
    <form
      autocomplete="off"
      @submit.prevent="handleSubmit"
    >
      <div>
        <div class="mb-4 input-field">
          <input
            id="email"
            v-model="formData.email"
            v-focus
            class="input-field"
            type="text"
            name="email"
            placeholder="Email"
          >
        </div>

        <AppButtonGroup class="flex-col">
          <AppButton
            :processing="isSubmitting"
            class="btn-solid btn-primary w-full !rounded-none"
            type="submit"
          >
            {{ isSubmitting ? 'Sending email...' : 'Reset Password' }}
          </AppButton>

          <AppRouterButton
            :to="{ name: 'app_auth_login' }"
            class="w-full btn-outline btn-primary !rounded-none"
          >
            Back to Sign in
          </AppRouterButton>
        </AppButtonGroup>
      </div>
    </form>
  </div>
</template>

<script setup>
import { HttpStatusCode } from 'axios';
import { reactive, ref } from 'vue';

import { AppButton } from '@/components/app';

import { useHttp } from '@/composables';
import AppRouterButton from '@/components/app/AppRouterButton.vue';
import { AppButtonGroup } from '@/components/app';

const emit = defineEmits(['email-sent']);

const formData = reactive({
  email: import.meta.env.DEV ? 'admin@example.com' : null,
});

const isSubmitting = ref(false);

const handleSubmit = async () => {
  isSubmitting.value = true;

  const response = await useHttp().post(
    '/auth/forgot-password',
    { email: formData.email },
  );

  if (response.statusCode === HttpStatusCode.Ok) {
    emit('email-sent', formData.email);
  }

  isSubmitting.value = false;
};
</script>
